import styles from "./ConfirmPopup.module.scss";
import React from "react";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { useTranslation } from "react-i18next";

interface IConfirmPopupProps {
  iconPath: string;
  title: string;
  description: string;
  onClickYes: () => void;
  onClickNo: () => void;
  textForConfirmBtn?: string;
  textForRejectBtn?: string;
  yesButtonLoader?: boolean;
}

const ConfirmPopup: React.FC<IConfirmPopupProps> = ({
  iconPath,
  title,
  description,
  onClickYes,
  onClickNo,
  textForConfirmBtn,
  textForRejectBtn,
  yesButtonLoader,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <img className={styles.image} src={iconPath} alt={"icon"} />
        <h3 className={`${styles.title}`}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <div className={styles.btnWrapper}>
          <CustomButton
            text={textForRejectBtn ? textForRejectBtn : t("No")}
            type={"button"}
            typeStyle={"outline"}
            functionOnClick={onClickNo}
          />
          <CustomButton
            text={textForConfirmBtn ? textForConfirmBtn : t("Yes")}
            type={"button"}
            typeStyle={"fill"}
            functionOnClick={onClickYes}
            showLoading={yesButtonLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
